// extracted by mini-css-extract-plugin
export default {"Avatar":"styles_Avatar__n8xgF","text":"styles_text__5zehS"};